import React, { Component } from 'react';
import './SubNavbar.css';
import { post, get, put, del } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
// import { getFreshToken } from '../../custom_libraries/auth';
import urls from '../../custom_libraries/urls';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
        Paper, Typography, Box } from '@mui/material';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import { Switch, FormControlLabel, Checkbox } from '@mui/material';
import DirectionsCarFilledRounded from '@mui/icons-material/DirectionsCarFilledRounded';
import TwoWheelerRounded from '@mui/icons-material/TwoWheelerRounded';
import DirectionsWalkRounded from '@mui/icons-material/DirectionsWalkRounded';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#2f3541",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class DeviceSpecificNotifications extends Component { 
  constructor(props) {
    super(props);
    this.state = {
      // emails: "",
      defaultEmailSaved: false, // Track if default email is saved
      // emails: [""], // 1 default email inputs
      emails: [   //for multiple email inputs now adding the alert email toggle and alert type selection in each block
          {
            value: "",
            chm_email_enabled: false,
            alerts_email_enabled: false,
            alerts: {
              person: false,
              vehicle: false,
              intruder: false
            }
          }
        ],

      error: "",
      success: false,
      error2: false,
      error1: false,
      warning: false,
      success_report: false,
      warning_report: false,
      open_progress_bar: false,
      deviceId: "",
      devices: [],
      errordelete:"",
      emailSaveError:"",
    };
  }

  componentDidMount() {
    localStorage.getItem(globalVariables.DEVICE_ID);
    this.setState({ deviceId: localStorage.getItem(globalVariables.DEVICE_ID) });
    this.fetchUserSettings( localStorage.getItem(globalVariables.DEVICE_ID));
    const storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
    this.setState({ user_type: storedUserType });
    
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.error !== prevState.error ||
      this.state.error1 !== prevState.error1 ||
      this.state.error2 !== prevState.error2 ||
      this.state.success !== prevState.success ||
      this.state.warning !== prevState.warning ||
      this.state.warning_report !== prevState.warning_report ||
      this.state.success_report !== prevState.success_report ||
      this.state.errordelete !== prevState.errordelete
    ) {
      if (
        this.state.error ||
        this.state.error1 ||
        this.state.error2 ||
        this.state.success ||
        this.state.warning ||
        this.state.warning_report ||
        this.state.success_report ||
        this.state.errordelete
      ) {
        setTimeout(() => {
          this.setState({
            error: false,
            success: false,
            error1: false,
            error2: false,
            warning: false,
            success_report: false,
            warning_report: false,
            errordelete: false,
          });
        }, 3000); // 3 second
      }
    }
  }

  validateEmails = (email) => {
    // const emailRegex =
    //   /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(, *[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
    // return emailRegex.test(emailList);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };


  handleDefaultEmailChange = (event) => {
    this.setState({ defaultEmail: event.target.value });
  };

  // handleInputChange = (index, value) => {

  //   const emails = [...this.state.emails];
  //   emails[index] = value;
  //   this.setState({ emails });

  //   // Validate the individual email
  //   if (value && !this.validateEmails(value)) {
  //     this.setState({ error: `Invalid email format at position ${index + 1}.` });
  //   } else {
  //     this.setState({ error: "" });
  //   }
  // };

  handleInputChange = (index, value) => {
  const emails = [...this.state.emails];
  emails[index].value = value;
  this.setState({ emails });

  if (value && !this.validateEmails(value)) {
    this.setState({ error: `Invalid email format at position ${index + 1}.` });
  } else {
    this.setState({ error: "" });
  }
};

  handleAlertToggle = (index) => {
  const emails = [...this.state.emails];

  emails[index].alerts_email_enabled =
    !emails[index].alerts_email_enabled;

  // auto-reset when disabled
  if (!emails[index].alerts_email_enabled) {
    emails[index].alerts = {
      person: false,
      vehicle: false,
      intruder: false
    };
  }

  this.setState({ emails });
};

  handleAlertCheckbox = (index, type) => {
  const emails = [...this.state.emails];
  emails[index].alerts[type] = !emails[index].alerts[type];
  this.setState({ emails });
};

handleChmEmailToggle = (index) => {
  const emails = [...this.state.emails];

  emails[index].chm_email_enabled =
    !emails[index].chm_email_enabled;

  this.setState({ emails });
};



  fetchUserSettings = async (devId) => {
    try {
      //   this.startLoading();
      let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth token---------", access_token);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      }

      
      const response = await get(urls.SMTP_ALERTS_DEVICE_SPECIFIC_EMAIL(devId), headers);
      console.log("API Response for fetch user settings:", response);
      
      const toBool = v => v === true || v === "true";
      let emailArray = [];
      if (response && Array.isArray(response)) {
        // const emailString = response || "";
        // const emailArray = emailString ? emailString.split(",").map(email => email.trim()) : [""];
        
         emailArray = response.map(e => ({
          id: e.id, // each email object has a unique 'id' field from the API
          isNew: false,
          value: e.email,
          alerts_email_enabled: toBool(e.alert_email),
          alerts: {
            person: toBool(e.person),
            vehicle: toBool(e.vehicle),
            intruder: toBool(e.intruder)
          },
          chm_email_enabled: toBool(e.camera_health)
        }));

        this.setState({
          emails: emailArray,
        });
      }

      if (emailArray.length === 0) {
          emailArray = [
            {
              value: "",
              chm_email_enabled: false,
              alerts_email_enabled: false,
              alerts: {
                person: false,
                vehicle: false,
                intruder: false
              }
            }
          ];
          this.setState({
          emails: emailArray,
        });
        }
      
    } catch (error) {
      console.error("Error fetching user settings:", error);
       this.setState({error1:true});
    }
  };

  jsonData = () => {
    const { defaultEmail, emails, deviceId } = this.state;

    let data = {

      "specific_email": emails.join(",")

    }
    console.log("saving json data===> ", data);
    return JSON.stringify(data)
  }


  handleSave = async () => {
    const { defaultEmail, emails, deviceId } = this.state;
    console.log("Emails deviceId to be saved===> ", deviceId);

    // Filter out empty or whitespace-only emails
    // const hasEmptyEmail = emails.some(email => email.trim() === "");
    const normalizedEmails = emails.map(e => ({
      ...e,
      value: e.value.trim().toLowerCase()
    }));
    const hasEmptyEmail = normalizedEmails.some(e => e.value === "");
    const hasInvalidEmail = normalizedEmails.some(
  e => e.value !== "" && !this.validateEmails(e.value)
);

  if (hasEmptyEmail) {
    this.setState({ warning: true, emailSaveError: "Email field cannot be empty." });
    return;
  }
  // Check if defaultEmail is empty or invalid
    if (hasInvalidEmail) {
      this.setState({ warning: true, emailSaveError: "Please enter a valid email address." });
      return;
    }


    if ( !deviceId) {
      // alert("No emails provided. Emails not saved.");
      this.setState({ warning: true, emailSaveError: "something went wrong, Cannot save the email settings" });
      return;
    }
    // Update state before saving
    this.setState({ emails}, async () => {
      const payload = {
      emails: this.state.emails.map(e => ({
        email: e.value,
        alert_email: e.alerts_email_enabled,
        person: e.alerts_email_enabled ? e.alerts.person : false,
        vehicle: e.alerts_email_enabled ? e.alerts.vehicle : false,
        intruder: e.alerts_email_enabled ? e.alerts.intruder : false,
        camera_health: e.chm_email_enabled
      }))
    };
    console.log("Payload to be sent to API===> ", payload);

    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
    // console.log("--------auth token---------", access_token);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_token}`
    }
    console.log("--------headers---------", headers);
    let url = urls.SMTP_ALERTS_DEVICE_SPECIFIC_EMAIL(deviceId);
    console.log("--------API URL---------", url);
    let response = await post(urls.SMTP_ALERTS_DEVICE_SPECIFIC_EMAIL(deviceId), JSON.stringify(payload), headers);
    console.log("response of email save===> ", response);
    this.stopLoading();
    if (response !== false && response.message === "Email alerts created/updated successfully.") {
      // alert("Settings saved successfully.");
      this.setState({ success: true, defaultEmailSaved: true }, () => {
        this.fetchUserSettings(deviceId); // Refresh emails in UI
      });
    } else if (response !== false && response.error && response.error.includes("already exists in request")) {
      // alert("Error saving emails. Please try again.");
      this.setState({ error2: true });
    }
    else if (response !== false && response.detail && response.detail === "emails must be a list") {
      this.setState({errordelete: true})
    }
    else {
      // alert("Error saving emails. Please try again.");
      this.setState({ error2: true });
    }
  });
  };

  handleDemoReport = () => {
    const { emails } = this.state;

    if (this.validateEmails(emails)) {
      // alert(`Sending demo report to: ${emails}`);
      this.setState({ success_report: true });
    } else {
      // alert("Please enter valid email(s) to send the report.");
      this.setState({ warning_report: true })
    }
  };

  startLoading = () => {
    this.setState({ open_progress_bar: true })
  }

  stopLoading = () => {
    this.setState({ open_progress_bar: false })
  }

  // addEmailField = () => {
  //   this.setState((prevState) => {
  //     const emails = Array.isArray(prevState.emails)
  //       ? prevState.emails
  //       : typeof prevState.emails === 'string'
  //         ? prevState.emails.split(',').map(e => e.trim())
  //         : [];
  
  //     return {
  //       emails: [...emails, ""],
  //     };
  //   });
  // };

 addEmailField = () => {
  this.setState(prev => ({
    emails: [
      ...prev.emails,
      {
        id: `temp-${Date.now()}`,
        isNew: true, // Marks as a local row only
        value: "",
        alerts_email_enabled: false,
        alerts: {
          person: false,
          vehicle: false,
          intruder: false
        }
      }
    ]
  }));
};


  // getDevicesList = async (devId) => {
  //   const {emailString, defaultEmail, emails, deviceId } = this.state;
  //   try {
  //     let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
  //     console.log("--------auth tocken---------", access_tocken);
  //     let headers = {
  //       'content-type': 'application/json',
  //       'Authorization': `Bearer ${access_tocken}`
  //     }
  //     // const response = await get(urls.GET_DEVICES, headers); // API call
  //     const response = await get(urls.DEVICE_DETAILS(devId), headers); //Api for devices w.r.t dealer's registered sites.
  //     console.log("API Response:", response)

  //     if (response && response.data && response.data[0]) {
  //       const deviceData = response.data[0];
  
  //       // ✅ Correctly extract and split the email string
  //       const emailString = deviceData.specific_email || "";
  //       const emailArray = emailString
  //         ? emailString.split(',').map(email => email.trim())
  //         : [""];
  
  //       this.setState({
  //         devices: deviceData,
  //         emails: emailArray
  //       });
  //     } else {
  //       console.error("No data returned from the API");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching devices from API:", error);
  //   }
  // };

  handleDropdownInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  
//   removeEmailField = (index) => {
//   // const emails = Array.isArray(this.state.emails) ? [...this.state.emails] : [];
//   // emails.splice(index, 1);
//   // this.setState({ emails });

//   const { emails, deviceId } = this.state;

//   const emailToRemove = emails[index];

//   // Always remove from UI first
//   const updatedEmails = [...emails];
//   updatedEmails.splice(index, 1);

//   this.setState({
//     emails:
//       updatedEmails.length > 0
//         ? updatedEmails
//         : [
//             {
//               value: "",
//               alerts_email_enabled: false,
//               alerts: {
//                 person: false,
//                 vehicle: false,
//                 intruder: false,
//               },
//             },
//           ],
//   });

//   // 🔹 If field is empty OR newly added → no API call needed
//   if (!emailToRemove || !emailToRemove.value?.trim()) {
//     return;
//   }

//   this.handleDeleteEmail(index);
// };

removeEmailField = (index) => {
  const { emails } = this.state;
  const emailToRemove = emails[index];

  if (!emailToRemove) return;

  // Identify if it is a record that exists on the server
  const isServerRecord = emailToRemove.isNew === false; 

  const updatedEmails = emails.filter((_, i) => i !== index);
  const finalEmails = updatedEmails.length > 0 ? updatedEmails : [this.getBlankRow()];

  this.setState({ emails: finalEmails }, () => {
    // Check if it was a saved record and has a value
    if (isServerRecord && emailToRemove.value?.trim()) {
      this.handleDeleteEmail(emailToRemove.value); 
    }
  });
};

getBlankRow = () => {
  return {
    id: `temp-${Date.now()}`,
    isNew: true, 
    value: "",
    chm_email_enabled: false,
    alerts_email_enabled: false,
    alerts: {
      person: false,
      vehicle: false,
      intruder: false
    }
  };
};

// handleDeleteEmail = async (index) => {
//   console.log("Attempting to delete email at index from DB:", index);
//   const { deviceId, emails } = this.state;

//   if (!deviceId) {
//     this.setState({
//       warning: true,
//       emailSaveError: "Device not found. Cannot delete email."
//     });
//     return;
//   }
//   if (!index) {
//     this.setState({
//       warning: true,
//       emailSaveError: "Device not found. Cannot delete email."
//     });
//     return;
//   }

//   const emailToDelete = emails[index];

//   if (!emailToDelete || !emailToDelete.value) {
//     return;
//   }

//   try {
//     this.startLoading();

//     let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

//     const payload = {
//       emails: [emailToDelete.value]
//     };

//     console.log("Deleting email payload =>", payload);

//     const response = await fetch(urls.SMTP_ALERTS_DEVICE_SPECIFIC_EMAIL(deviceId), 
//               { method: 'DELETE',
//               headers : {
//                   'content-type': 'application/json',
//                   'Authorization': `Bearer ${access_token}`
//               },
//               body: JSON.stringify(payload)
//               });

//     console.log("Delete response =>", response);

//     this.stopLoading();

//     if (response && response.status === 200) {
//       // ✅ Remove from UI after success
//       const updatedEmails = [...emails];
//       updatedEmails.splice(index, 1);

//       this.setState({
        
//         success: true
//       });
//     } else {
//       this.setState({
//         error2: true
//       });
//     }
//   } catch (error) {
//     console.error("Error deleting email:", error);
//     this.stopLoading();
//     this.setState({
//       error2: true
//     });
//   }
// };

handleDeleteEmail = async (emailValue) => { // Accept string, not index
  console.log("Attempting to delete email from DB:", emailValue);
  const { deviceId } = this.state;

  if (!deviceId || !emailValue) return;

  try {
    this.startLoading();
    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const payload = {
      emails: [emailValue] // Use the passed string
    };

    const response = await fetch(urls.SMTP_ALERTS_DEVICE_SPECIFIC_EMAIL(deviceId), { 
      method: 'DELETE',
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      },
      body: JSON.stringify(payload)
    });

    this.stopLoading();

    if (response && response.status === 200) {
      this.setState({ success: true });
    } else {
      this.setState({ error2: true });
    }
  } catch (error) {
    console.error("Error deleting email:", error);
    this.stopLoading();
    this.setState({ error2: true });
  }
};  

  render() {
    const { emails, error, error2, success_report, warning_report, success, error1, warning, devices, deviceId, errordelete } = this.state;


    return (
      <ThemeProvider theme={darkTheme}> 
        <CssBaseline />
        <Box sx={{ backgroundColor:"#323744" }} >
          <Box  className="setting-container" style={{ width: '93%', alignItems:"center"}}>
            <div style={{ width: '100%' }}>
              {error2 ? (
                <Alert severity="error">Error saving emails. Either the email already exists or server error. Please try again.!</Alert>
              ) : success ? (
                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                  "Settings saved successfully."
                </Alert>
              ) : success_report ? (
                <Alert severity="success">
                  "Sending demo report to: ${emails}"
                </Alert>
              ) : warning_report ? (
                <Alert severity="warning">
                  "Please enter valid email(s) to send the report."
                </Alert>
              ) : warning_report ? (
                <Alert severity="warning">
                  "Please enter valid email(s) to send the report."
                </Alert>
              ) :errordelete ? (
                <Alert severity="error">
                  "At least one email is required. You can disable the toggle, but cannot remove all emails."
                </Alert>
              ) : warning ? (
                <Alert severity="warning">
                  {this.state.emailSaveError}
                </Alert>
              ) : null}
            </div>
            
            <Box component={Paper} style={{ display:"flex", fontSize: "13px", justifyContent:'space-between', marginBottom: "20px", width: '100%', border: "1px solid #ffffff36", borderRadius:"5px"}}>
              {/* <h3>Email addresses</h3> sx={{backgroundColor: "#313848", border: "1px solid #ffffff36", borderRadius:"5px"}}*/}
              <p style={{ padding:"5px" }}>
              <h4>Steps to follow:</h4>
                - Click (+ Add) to add more email recipients, one per field and (Save) the setting.<br/>
                - Click (-) to remove an email field.<br/>
                
              </p>
              <p style={{ padding:"8px" }}>
                <h4>Settings Info.</h4>
                <b>- Detection: </b>Enable to receive filtered motion alerts<br/>
                <b>- CHM Health: </b>Enable to receive camera updates based on the CHM schedule<br/>
              </p>
            </Box>
            <div style={{ width: '100%' }}>
              {error && <p style={{ color: "red", fontSize: "12px" }}>{error}</p>}

              {/* <div style={{ marginTop: "10px" }}> style={{ tableLayout: 'auto', width: '100%'}}*/}
              <TableContainer component={Paper} sx={{backgroundColor: "#303640", border: "1px solid #ffffff36", borderRadius:"5px"}}>
                <Table style={{ tableLayout: 'auto', width: '100%'}}>
                  <TableHead>
                    <TableRow>
                        {[
                        { label: 'Recipient', id: 'h-rec' },
                        { label: 'Camera Health', id: 'h-chm' },
                        { label: 'Detection', id: 'h-det' },
                        { label: <DirectionsWalkRounded
                          sx={{
                            backgroundColor: "#44c54c",
                            color: "white",
                            borderRadius: "50%",
                            padding: "3px",
                            fontSize: 35, // optional
                          }}
                        /> , id: 'h-walk' },
                        { label: <DirectionsCarFilledRounded 
                          sx={{
                            backgroundColor: "#639fd3",
                            color: "white",
                            borderRadius: "50%",
                            padding: "3px",
                            fontSize: 35, 
                          }}
                        />, id: 'h-car' },
                        { label: <TwoWheelerRounded 
                          sx={{
                            backgroundColor: "#de45f5ff",
                            color: "white",
                            borderRadius: "50%",
                            padding: "3px",
                            fontSize: 35, // optional
                          }}
                        />, id: 'h-bike' }
                        ].map((header) => (
                        <TableCell key={header.id}>
                            <Typography variant="subtitle2" fontWeight="bold">
                            {header.label}
                            </Typography>
                        </TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(this.state.emails || []).map((email, index) => ( 
                      <TableRow key={email.id}>
                      <TableCell>
                        <div style={{ display: "flex"}}>
                      
                          <input
                            type="email"
                            className="input-email"
                            value={email.value}
                            onChange={(e) => this.handleInputChange(index, e.target.value)}
                            placeholder={`Enter email ${index + 1}`}
                            style={{
                              width: "280px",
                            }}
                          />
                          {/* Logic: Only show the '-' button if it is NOT the first row */}
                          {/* {index !== 0 && ( */}
                          <button
                            type="button"
                            onClick={() => this.removeEmailField(index)}
                            id="clearUserLogButton"
                            style={{
                              minWidth: "25px",
                              height: "30px",
                              flexShrink: 0        
                            }}
                          >
                            -
                          </button>
                          {/* )} */}
                        </div>
                      </TableCell>
                      <TableCell>
                        
                          <Switch
                            checked={email.chm_email_enabled}
                            onChange={() => this.handleChmEmailToggle(index)}
                            color="primary"
                            size="medium"
                            disabled={!email.value}
                          />
                      
                      </TableCell>
                      <TableCell>
                        {/* ALERT EMAIL TOGGLE */}
                          <Switch
                            checked={email.alerts_email_enabled}
                            onChange={() => this.handleAlertToggle(index)}
                            color="primary"
                            size="medium"
                            disabled={!email.value}
                          />
                      </TableCell>
                      <TableCell>
                          <Checkbox
                            checked={email.alerts.person}
                            onChange={() =>
                              this.handleAlertCheckbox(index, "person")
                            }
                            disabled={!email.alerts_email_enabled}
                            size='medium'
                          />
                      </TableCell>
                      <TableCell>
                          <Checkbox
                            checked={email.alerts.vehicle}
                            onChange={() =>
                              this.handleAlertCheckbox(index, "vehicle")
                            }
                            disabled={!email.alerts_email_enabled}
                            size='medium'
                          />
                        </TableCell>
                        <TableCell>
                          <Checkbox
                            checked={email.alerts.intruder}
                            onChange={() =>
                              this.handleAlertCheckbox(index, "intruder")
                            }
                            disabled={!email.alerts_email_enabled}
                            size='medium'
                          />
                      </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="button"
                  onClick={this.addEmailField}
                  id="rowsPerPageButton"
                  style={{
                    minWidth: "25px",
                    // height:"34px",
                    marginTop: '12px'
                  }}
                >
                  + Add
                </Button>

                <Button id="rowsPerPageButton" style={{ marginTop: '12px' }}
                  onClick={this.handleSave}
                > Save
                </Button>

              </div>
              {/* </div> */}
            </div>
          </Box>
          {/* Backdrop with Circular Progress */}
          <Backdrop open={this.state.open_progress_bar}>
            <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img src={WebLogo} alt="web-logo" style={{ backgroundColor: '#001f54', borderRadius: '100px' }} />
            </div>
          </Backdrop>
        </Box>
      </ThemeProvider>
    ); 
  }
}

export default DeviceSpecificNotifications;